import { buildOptimizationResult } from "../i18n/optimizationCopy";
import type { Locale } from "../i18n/locale";
import type { AudienceMode } from "./audienceMode";
import { DEFAULT_AUDIENCE_MODE } from "./audienceMode";
import type { CostEstimate, OptimizationResult, Workload } from "./types";

export function analyzeOptimization(
  w: Workload,
  estimate: CostEstimate,
  locale: Locale = "uk",
  audience: AudienceMode = DEFAULT_AUDIENCE_MODE,
): OptimizationResult {
  return buildOptimizationResult(w, estimate, locale, audience);
}
